var map = {
	"./1-choice-1-1.mp3": "2f64",
	"./1-choice-1-2.mp3": "eff5",
	"./1-choice-1-3.mp3": "1118",
	"./1-choice-2-1.mp3": "52be",
	"./1-choice-2-2.mp3": "ef42",
	"./1-choice-2-3.mp3": "a179",
	"./1-choice-3-1.mp3": "e0d6",
	"./1-choice-3-2.mp3": "f132",
	"./1-choice-3-3.mp3": "8c61",
	"./1-choice-3-4.mp3": "a99f",
	"./1-choice-4-1.mp3": "1f64",
	"./1-choice-4-2.mp3": "4f68",
	"./1-choice-4-3.mp3": "0194",
	"./1-choice-4-4.mp3": "292e",
	"./1-choice-5-1.mp3": "56d3",
	"./1-choice-5-2.mp3": "d2ee",
	"./1-choice-5-3.mp3": "2fd2",
	"./1-choice-5-4.mp3": "da39",
	"./1-choice-6-1.mp3": "ba07",
	"./1-choice-6-2.mp3": "9063",
	"./1-choice-6-3.mp3": "af49",
	"./1-choice-7-1.mp3": "129c",
	"./1-choice-7-2.mp3": "331d",
	"./1-choice-7-3.mp3": "fa81",
	"./1-feedback-1-1.mp3": "048c",
	"./1-feedback-1-2.mp3": "cce4",
	"./1-feedback-1-3.mp3": "c496",
	"./1-feedback-2-1.mp3": "a04c",
	"./1-feedback-2-2.mp3": "1b0d",
	"./1-feedback-2-3.mp3": "7b21",
	"./1-feedback-3-1.mp3": "1064",
	"./1-feedback-3-2.mp3": "025b",
	"./1-feedback-3-3.mp3": "b766",
	"./1-feedback-3-4.mp3": "37b1",
	"./1-feedback-4-1.mp3": "18dc",
	"./1-feedback-4-2.mp3": "2e13",
	"./1-feedback-4-3.mp3": "3fd2",
	"./1-feedback-4-4.mp3": "bcb7",
	"./1-feedback-5-1.mp3": "4c70",
	"./1-feedback-5-2.mp3": "f398",
	"./1-feedback-5-3.mp3": "1043",
	"./1-feedback-5-4.mp3": "15bb",
	"./1-feedback-6-1.mp3": "b19f",
	"./1-feedback-6-2.mp3": "d62d",
	"./1-feedback-6-3.mp3": "6ae0",
	"./1-feedback-7-1.mp3": "4ad1",
	"./1-feedback-7-2.mp3": "7e00",
	"./1-feedback-7-3.mp3": "c61e",
	"./1-instructions.mp3": "4a00",
	"./1-question-1.mp3": "f5bb",
	"./1-question-2.mp3": "9f18",
	"./1-question-3.mp3": "2c70",
	"./1-question-4.mp3": "9f32",
	"./1-question-5.mp3": "7931",
	"./1-question-6.mp3": "263d",
	"./1-question-7.mp3": "7c4c",
	"./1-result-6-1-1.mp3": "be11",
	"./1-result-6-1-2.mp3": "83a5",
	"./1-result-6-2-1.mp3": "cbc6",
	"./1-result-7-1-1.mp3": "4eae",
	"./1-result-7-1-2.mp3": "8ae5",
	"./1-result-7-2-1.mp3": "d702",
	"./1-setup-1-1.mp3": "897e",
	"./1-setup-1-2.mp3": "c710",
	"./1-setup-1-3.mp3": "60a4",
	"./1-setup-2-1.mp3": "31cf",
	"./1-setup-2-2.mp3": "1f51",
	"./1-setup-2-3.mp3": "3092",
	"./1-setup-2-4.mp3": "9d86",
	"./1-setup-3-1.mp3": "f071",
	"./1-setup-3-2.mp3": "7699",
	"./1-setup-3-3.mp3": "8ddf",
	"./1-setup-3-4.mp3": "b6cc",
	"./1-setup-3-5.mp3": "5ea7",
	"./1-setup-3-6.mp3": "c4a7",
	"./1-setup-4-1.mp3": "7115",
	"./1-setup-4-2.mp3": "a4fa",
	"./1-setup-5-1.mp3": "d105",
	"./1-setup-6-1.mp3": "bd53",
	"./1-setup-6-2.mp3": "9bc0",
	"./1-setup-6-3.mp3": "87f8",
	"./1-setup-6-4.mp3": "973b",
	"./1-setup-6-5.mp3": "6004",
	"./1-setup-6-6.mp3": "91c3",
	"./1-setup-7-1.mp3": "5365",
	"./1-setup-7-2.mp3": "efca",
	"./1-setup-7-3.mp3": "4399",
	"./2-choice-1-1.mp3": "a3e1",
	"./2-choice-1-2.mp3": "c647",
	"./2-choice-1-3.mp3": "2159",
	"./2-choice-2-1.mp3": "a12a",
	"./2-choice-2-2.mp3": "bf4b",
	"./2-choice-2-3.mp3": "50a7",
	"./2-choice-3-1.mp3": "a28a",
	"./2-choice-3-2.mp3": "4397",
	"./2-choice-3-3.mp3": "ba05",
	"./2-choice-4-1.mp3": "34c0",
	"./2-choice-4-2.mp3": "d766",
	"./2-choice-4-3.mp3": "5fd7",
	"./2-choice-5-1.mp3": "aca6",
	"./2-choice-5-2.mp3": "05bb",
	"./2-choice-5-3.mp3": "43ec",
	"./2-choice-6-1.mp3": "50c4",
	"./2-choice-6-2.mp3": "266d",
	"./2-choice-6-3.mp3": "2630",
	"./2-choice-7-1.mp3": "2ccb",
	"./2-choice-7-2.mp3": "ab82",
	"./2-choice-7-3.mp3": "aff8",
	"./2-feedback-1-1.mp3": "f5a6",
	"./2-feedback-1-2.mp3": "b910",
	"./2-feedback-1-3.mp3": "ed52",
	"./2-feedback-2-1.mp3": "cf25",
	"./2-feedback-2-2.mp3": "4934",
	"./2-feedback-2-3.mp3": "5ad0",
	"./2-feedback-3-1.mp3": "6926",
	"./2-feedback-3-2.mp3": "e7ae",
	"./2-feedback-3-3.mp3": "7388",
	"./2-feedback-4-1.mp3": "b126",
	"./2-feedback-4-2.mp3": "4268",
	"./2-feedback-4-3.mp3": "65b4",
	"./2-feedback-5-1.mp3": "0f66",
	"./2-feedback-5-2.mp3": "2280",
	"./2-feedback-5-3.mp3": "bef1",
	"./2-feedback-6-1.mp3": "e644",
	"./2-feedback-6-2.mp3": "18ef",
	"./2-feedback-6-3.mp3": "7317",
	"./2-feedback-7-1.mp3": "5a63",
	"./2-feedback-7-2.mp3": "6937",
	"./2-feedback-7-3.mp3": "be58",
	"./2-instructions.mp3": "f920",
	"./2-question-1.mp3": "c3cf",
	"./2-question-2.mp3": "2300",
	"./2-question-3.mp3": "524f",
	"./2-question-4.mp3": "c290",
	"./2-question-5.mp3": "207c",
	"./2-question-6.mp3": "ee5e",
	"./2-question-7.mp3": "3158",
	"./2-result-1-1-1.mp3": "b43c",
	"./2-result-1-2-1.mp3": "c02f",
	"./2-result-1-3-1.mp3": "9db2",
	"./2-result-2-1-1.mp3": "b04a",
	"./2-result-2-2-1.mp3": "68f6",
	"./2-result-2-3-1.mp3": "1265",
	"./2-result-3-1-1.mp3": "bbd9",
	"./2-result-3-2-1.mp3": "ef73",
	"./2-result-3-2-2.mp3": "87d9",
	"./2-result-3-3-1.mp3": "64ec",
	"./2-result-4-1-1.mp3": "78fc",
	"./2-result-5-1-1.mp3": "fad8",
	"./2-result-5-1-2.mp3": "9968",
	"./2-result-6-1-1.mp3": "cec6",
	"./2-result-6-2-1.mp3": "2502",
	"./2-result-6-2-2.mp3": "51ae",
	"./2-result-7-1-1.mp3": "2004",
	"./2-result-7-2-1.mp3": "6019",
	"./2-result-7-3-1.mp3": "e618",
	"./2-setup-1-1.mp3": "9357",
	"./2-setup-1-2.mp3": "5561",
	"./2-setup-1-3.mp3": "c54e",
	"./2-setup-2-1.mp3": "fd6c",
	"./2-setup-2-2.mp3": "ae02",
	"./2-setup-2-3.mp3": "a2e7",
	"./2-setup-3-1.mp3": "53be",
	"./2-setup-3-2.mp3": "9dcc",
	"./2-setup-3-3.mp3": "83e2",
	"./2-setup-3-4.mp3": "c055",
	"./2-setup-3-5.mp3": "eb3c",
	"./2-setup-4-1.mp3": "baa0",
	"./2-setup-4-2.mp3": "e0c5",
	"./2-setup-4-3.mp3": "946e",
	"./2-setup-4-4.mp3": "8253",
	"./2-setup-5-1.mp3": "94ef",
	"./2-setup-5-2.mp3": "0ee8",
	"./2-setup-6-1.mp3": "2f6d",
	"./2-setup-6-2.mp3": "6be9",
	"./2-setup-7-1.mp3": "0154",
	"./2-setup-7-2.mp3": "13c1",
	"./2-setup-7-3.mp3": "aaf0",
	"./3-choice-1-1.mp3": "c15e",
	"./3-choice-1-2.mp3": "5b4c",
	"./3-choice-1-3.mp3": "9548",
	"./3-choice-2-1.mp3": "4f94",
	"./3-choice-2-2.mp3": "ba08",
	"./3-choice-2-3.mp3": "16f5",
	"./3-choice-3-1.mp3": "aa08",
	"./3-choice-3-2.mp3": "5f30",
	"./3-choice-3-3.mp3": "82c3",
	"./3-choice-4-1.mp3": "2e70",
	"./3-choice-4-2.mp3": "548e",
	"./3-choice-4-3.mp3": "4370",
	"./3-choice-5-1.mp3": "9f7c",
	"./3-choice-5-2.mp3": "cbeb",
	"./3-choice-5-3.mp3": "80ac",
	"./3-choice-6-1.mp3": "8b20",
	"./3-choice-6-2.mp3": "3b6b",
	"./3-choice-6-3.mp3": "5225",
	"./3-choice-7-1.mp3": "b2a9",
	"./3-choice-7-2.mp3": "036a",
	"./3-choice-7-3.mp3": "8f0d",
	"./3-choice-8-1.mp3": "62ec",
	"./3-choice-8-2.mp3": "53a4",
	"./3-choice-8-3.mp3": "2a80",
	"./3-feedback-1-1.mp3": "63de",
	"./3-feedback-1-2.mp3": "9c3b",
	"./3-feedback-1-3.mp3": "50ca",
	"./3-feedback-2-1.mp3": "604b",
	"./3-feedback-2-2.mp3": "bdae",
	"./3-feedback-2-3.mp3": "d0b5",
	"./3-feedback-3-1.mp3": "2dd9",
	"./3-feedback-3-2.mp3": "8424",
	"./3-feedback-3-3.mp3": "2abd",
	"./3-feedback-4-1.mp3": "4c15",
	"./3-feedback-4-2.mp3": "6055",
	"./3-feedback-4-3.mp3": "62ad",
	"./3-feedback-5-1.mp3": "ea45",
	"./3-feedback-5-2.mp3": "1406",
	"./3-feedback-5-3.mp3": "1881",
	"./3-feedback-6-1.mp3": "17d6",
	"./3-feedback-6-2.mp3": "fdfb",
	"./3-feedback-6-3.mp3": "b1fb",
	"./3-feedback-7-1.mp3": "b554",
	"./3-feedback-7-2.mp3": "ab70",
	"./3-feedback-7-3.mp3": "3199",
	"./3-feedback-8-1.mp3": "11cd",
	"./3-feedback-8-2.mp3": "3ed6",
	"./3-feedback-8-3.mp3": "43af",
	"./3-instructions.mp3": "bdd8",
	"./3-question-1.mp3": "279a",
	"./3-question-2.mp3": "9694",
	"./3-question-3.mp3": "54ce",
	"./3-question-4.mp3": "c2b1",
	"./3-question-5.mp3": "87d6",
	"./3-question-6.mp3": "a7c7",
	"./3-question-7.mp3": "cd59",
	"./3-question-8.mp3": "d84a",
	"./3-result-1-1-1.mp3": "74e5",
	"./3-result-1-2-1.mp3": "d2a2",
	"./3-result-1-3-1.mp3": "ffed",
	"./3-result-2-1-1.mp3": "3b3e",
	"./3-result-2-2-1.mp3": "7c13",
	"./3-result-2-3-1.mp3": "6419",
	"./3-result-3-1-1.mp3": "b373",
	"./3-result-3-2-1.mp3": "6fe8",
	"./3-result-3-3-1.mp3": "a1d7",
	"./3-result-4-1-1.mp3": "a815",
	"./3-result-4-3-1.mp3": "e981",
	"./3-result-4-3-2.mp3": "1bd4",
	"./3-result-5-2-1.mp3": "2a2f",
	"./3-result-5-2-2.mp3": "ec13",
	"./3-result-6-1-1.mp3": "0e0c",
	"./3-result-6-2-1.mp3": "b67b",
	"./3-result-6-3-1.mp3": "f073",
	"./3-result-7-2-1.mp3": "f8b1",
	"./3-result-7-3-1.mp3": "2628",
	"./3-result-7-3-2.mp3": "95ed",
	"./3-result-8-1-1.mp3": "e336",
	"./3-result-8-1-2.mp3": "3e52",
	"./3-result-8-1-3.mp3": "94ec",
	"./3-result-8-3-1.mp3": "a6af",
	"./3-result-8-3-2.mp3": "4618",
	"./3-setup-1-1.mp3": "013b",
	"./3-setup-1-2.mp3": "9f1e",
	"./3-setup-1-3.mp3": "fa14",
	"./3-setup-2-1.mp3": "32fe",
	"./3-setup-2-2.mp3": "a0fa",
	"./3-setup-2-3.mp3": "40ab",
	"./3-setup-2-4.mp3": "bce4",
	"./3-setup-2-5.mp3": "8b05",
	"./3-setup-3-1.mp3": "414a",
	"./3-setup-3-2.mp3": "9b07",
	"./3-setup-3-3.mp3": "8981",
	"./3-setup-4-1.mp3": "9c29",
	"./3-setup-4-2.mp3": "9132",
	"./3-setup-4-3.mp3": "bc8a",
	"./3-setup-5-1.mp3": "6223",
	"./3-setup-5-2.mp3": "45e7",
	"./3-setup-5-3.mp3": "3082",
	"./3-setup-6-1.mp3": "3f88",
	"./3-setup-6-2.mp3": "f969",
	"./3-setup-6-3.mp3": "5f03",
	"./3-setup-7-1.mp3": "69d9",
	"./3-setup-7-2.mp3": "39cc",
	"./3-setup-8-1.mp3": "7e49",
	"./3-setup-8-10.mp3": "9b6e",
	"./3-setup-8-11.mp3": "5449",
	"./3-setup-8-2.mp3": "ac68",
	"./3-setup-8-3.mp3": "3a81",
	"./3-setup-8-4.mp3": "3448",
	"./3-setup-8-5.mp3": "b462",
	"./3-setup-8-6.mp3": "19ef",
	"./3-setup-8-7.mp3": "ca9d",
	"./3-setup-8-8.mp3": "2a7c",
	"./3-setup-8-9.mp3": "2033",
	"./4-conclusion.mp3": "8386",
	"./4-end.mp3": "d5a7",
	"./4-feedback-1-1.mp3": "c6b7",
	"./4-feedback-10-1.mp3": "8e26",
	"./4-feedback-11-1.mp3": "1667",
	"./4-feedback-2-1.mp3": "4fc3",
	"./4-feedback-3-1.mp3": "3e21",
	"./4-feedback-4-1.mp3": "5396",
	"./4-feedback-5-1.mp3": "70d5",
	"./4-feedback-6-1.mp3": "4b2a",
	"./4-feedback-7-1.mp3": "9be0",
	"./4-feedback-8-1.mp3": "0465",
	"./4-feedback-9-1.mp3": "1939",
	"./4-instructions.mp3": "2a8b",
	"./4-setup-1-1.mp3": "47a6",
	"./4-setup-10-1.mp3": "6c48",
	"./4-setup-11-1.mp3": "4dd9",
	"./4-setup-2-1.mp3": "ca71",
	"./4-setup-3-1.mp3": "77c7",
	"./4-setup-4-1.mp3": "8a9c",
	"./4-setup-5-1.mp3": "431c",
	"./4-setup-6-1.mp3": "127b",
	"./4-setup-7-1.mp3": "879d",
	"./4-setup-8-1.mp3": "e673",
	"./4-setup-9-1.mp3": "281b",
	"./baseball-award.mp3": "fac0",
	"./basketball-award.mp3": "b344",
	"./click-conversation.mp3": "fde6",
	"./click-phone.mp3": "aa73",
	"./cyberbullying-tips.mp3": "cbc8",
	"./football-award.mp3": "2b6f",
	"./game-on.mp3": "f85d",
	"./next.mp3": "7635",
	"./round-1.mp3": "5dd42",
	"./round-2.mp3": "585f",
	"./round-3.mp3": "d378",
	"./round-4.mp3": "89ae",
	"./should-you-post.mp3": "595c",
	"./soccer-award.mp3": "a167",
	"./start.mp3": "5e5f",
	"./win-game.mp3": "210e",
	"./your-certificate.mp3": "ad11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a901";